/* eslint-disable sort-keys */
import { Rows } from '../components/AuditLogsColumns';

export const dataMapper = (data: Rows[]): Record<string, string | number>[] =>
  data.map((item) => ({
    Category: item['category'] ?? '',
    BidNumber: item['bid_Number'] ?? '',
    BEMNumber: item['beM_Number'],
    Vendor: item['vendor_Name'] ?? '',
    VendorProgram: item['vendor_Program_Name'] ?? '',
    EventType: item['eventType'],
    ModifiedBy: item['modifiedBy'],
    ModifiedDate: item['modifiedDate'],
  }));
